/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { EtiologicalAgentDtoName } from './etiologicalAgentDtoName';

export interface EtiologicalAgentDto {
  /** Etiological agent code */
  code: string;
  /** Etiological agent name (multilingual) */
  name: EtiologicalAgentDtoName;
  /** Whether the agent is validated */
  validated: boolean;
  /** Etiology type code */
  etiologyTypeCode?: string;
}
